import { LayerItem } from '@ais-ui/react-openlayers';

export const updateZIndex = (layers: LayerItem[]) => {
  // It is the layers list that determines the z-index of the layers on the map
  layers.forEach((layerItem, index) => {
    layerItem.layer.setZIndex(index);
  });
};

export const addNewLayerAboveShipsLayer = (
  prevLayers: LayerItem[],
  newLayerItem: LayerItem
) => {
  const shipsLayerIndex = prevLayers.findIndex(
    (layer) => layer.name.toLowerCase() === 'vessels'
  );

  // If vessels layer is not present, add at the end (top)
  if (shipsLayerIndex === -1) {
    const updatedLayers = [...prevLayers, newLayerItem];
    updateZIndex(updatedLayers);
    return updatedLayers;
  } else {
    // Insert after the vessels layer (above it in z-order)
    const beforeAndIncludingShipsLayer = prevLayers.slice(
      0,
      shipsLayerIndex + 1
    );
    const afterShipsLayer = prevLayers.slice(shipsLayerIndex + 1);
    const updatedLayers = [
      ...beforeAndIncludingShipsLayer,
      newLayerItem,
      ...afterShipsLayer,
    ];
    updateZIndex(updatedLayers);
    return updatedLayers;
  }
};

export const addNewLayerBelowShipsLayer = (
  prevLayers: LayerItem[],
  newLayerItem: LayerItem
) => {
  const shipsLayerIndex = prevLayers.findIndex(
    (layer) => layer.name.toLowerCase() === 'vessels'
  );
  // If vessels layer is not present, the index will be -1, and then we will just append the new layer at the end.
  if (shipsLayerIndex === -1) {
    const updatedLayers = [...prevLayers, newLayerItem];
    updateZIndex(updatedLayers);
    return updatedLayers;
  } else {
    const beforeShipsLayers = prevLayers.slice(0, shipsLayerIndex);
    const afterAndIncludingShipsLayer = prevLayers.slice(shipsLayerIndex);
    const updatedLayers = [
      ...beforeShipsLayers,
      newLayerItem,
      ...afterAndIncludingShipsLayer,
    ];
    updateZIndex(updatedLayers);
    return updatedLayers;
  }
};

export const addNewLayerAtTop = (
  prevLayers: LayerItem[],
  newLayerItem: LayerItem
) => {
  // Add the new layer at the very end of the array (highest z-index)
  const updatedLayers = [...prevLayers, newLayerItem];
  updateZIndex(updatedLayers);
  return updatedLayers;
};
